/* eslint-disable consistent-return */
/* eslint-disable default-case */
import React, { useReducer } from 'react';
import PropTypes from 'prop-types';
import { AnswersContext } from '../../contexts';
import ACTIONS from '../../constants/actions';

const AnswersProvider = ({ children }) => {
  const initialAnswers = {
    ageAnswer: null,
    statusAnswer: null,
    ret_ageAnswer: null,
    incomeAnswer: null,
    marriedAnswer: null,
    dependentsAnswer: null,
    worryAnswer: null,
    hopeAnswer: null,
  };

  const answersReducer = (answers, action) => {
    switch (action.type) {
      case ACTIONS.SET_PERSONAL_INFO:
        return {
          ...answers,
          ageAnswer: action.payload.age,
          statusAnswer: action.payload.status,
          ret_ageAnswer: action.payload.ret_age,
        };
      case ACTIONS.SET_HOUSEHOLD_INFO:
        return {
          ...answers,
          marriedAnswer: action.payload.married,
          dependentsAnswer: action.payload.dependents,
        };
      case ACTIONS.SET_GOALS:
        return {
          ...answers,
          worryAnswer: action.payload.worry,
          hopeAnswer: action.payload.hope,
        };
      case ACTIONS.RESET_FORM:
        return initialAnswers;
    }
  };

  const [answers, answersDispatch] = useReducer(answersReducer, initialAnswers);

  return (
    <AnswersContext.Provider
      value={{
        answers,
        answersDispatch,
      }}
    >
      {children}
    </AnswersContext.Provider>
  );
};

AnswersProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AnswersProvider;
